import { LojistikIrsaliye } from "./lojistik-irsaliye";

export class LojistikIrsaliyelerPage {
    
  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: LojistikIrsaliye[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): LojistikIrsaliye[] {
    return this.pResults;
  }

  public set results(list: LojistikIrsaliye[]) {
    if (list != null) {
      this.pResults = list.map(t => new LojistikIrsaliye(t));
    }
  }
}
